export const BACK_ROUTE_MAP = {
    "/cabinet": "/",
    "/cabinet/link-email": "/cabinet",
    "/tariffs": "/",
    "/devices": "/",
    "/instruction": "/devices",
    "/paytype": "/tariffs",
    "/recalc": "/devices",
    "/history": "/cabinet",
};

export const PAYMENT_BACK_EVENT = "app:payment-back";

function isSharedInstructionPath(pathname) {
    return pathname.startsWith("/instruction/shared/");
}

export function getBackTarget(pathname) {
    return BACK_ROUTE_MAP[pathname] || null;
}

export function shouldShowBrowserNavigation(pathname) {
    return pathname !== "/" && pathname !== "/auth" && !isSharedInstructionPath(pathname);
}

export function shouldShowTelegramBackButton(pathname) {
    return pathname === "/payment" || (
        pathname !== "/" &&
        pathname !== "/auth" &&
        !isSharedInstructionPath(pathname)
    );
}
